import React from 'react';
import { Link } from 'react-router-dom';

const IndustriesPage = () => {
  const industries = [
    {
      title: "General Trading",
      image: "img/home-1.avif",
      description: "Navigating global trade compliance, international supply chain dynamics, import-export operational structures, and market penetration models.",
      solutions: ["Cross-Border Logistics Strategy", "Regulatory Compliance Mapping", "Supplier Risk Assessment & Auditing"]
    },
    {
      title: "Commodities Market",
      image: "img/ind-2.avif",
      description: "In-depth market intelligence, commodity price volatility modeling, risk hedging frameworks, and demand forecasting for physical commodities.",
      solutions: ["Supply & Demand Market Research", "Price Volatility & Hedging Analysis", "Global Trade Flow Intelligence"]
    },
    {
      title: "Raw Materials",
      image: "img/home-3.avif",
      description: "Strategic procurement, raw material sourcing resilience, upstream value chain analysis, and sustainable resource integration for heavy sectors.",
      solutions: ["Sustainable Sourcing Frameworks", "Procurement Cost Optimization", "Upstream Value Chain Integration"]
    },
    {
      title: "Industrial Businesses",
      image: "img/home-4.avif",
      description: "Operational restructuring, plant efficiency audits, lean manufacturing consultation, and corporate expansion strategies for industrial firms.",
      solutions: ["Operational Efficiency Audits", "Lean Process Implementation", "Industrial Expansion Planning"]
    }
  ];

  return (
    <div className="min-h-screen bg-[#faeee2]">
      <section className="relative pt-44 pb-20 md:pt-52 md:pb-28 overflow-hidden bg-brand-deepBrown">
        <div className="absolute inset-0 z-0">
          <img   
            src="img/ind-3.avif" 
            alt="Global Industries" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/75 backdrop-blur-[2px]"></div>
        </div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-aos="fade-up">
          <span className="inline-block px-5 py-1.5 rounded-full border border-brand-orange/40 bg-brand-orange/10 text-brand-orange text-xs md:text-sm font-bold tracking-widest uppercase mb-6 backdrop-blur-sm">
            SECTORS WE SERVE 
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-serif font-bold text-white mb-6 leading-tight">
            Target <span className="text-brand-orange">Industries</span>
          </h1>
          <p className="text-base md:text-lg text-[#faeee2]/90 leading-relaxed max-w-2xl mx-auto">
            Deep domain expertise tailored for complex global trade, raw material supply chains, commodity markets, and manufacturing sectors.
          </p>
        </div>
      </section>

      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            {industries.map((ind, idx) => (
              <div  
                key={idx} 
                className="bg-white rounded-3xl overflow-hidden border border-[#a17644]/20 shadow-lg hover:shadow-2xl transition-all duration-300 flex flex-col"
                data-aos="fade-up"
                data-aos-delay={idx * 100}
              >
                <div className="relative h-60 bg-[#f2decb] overflow-hidden">
                  <img 
                    src={ind.image}  
                    alt={ind.title} 
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.src = "img/ind-4.avif";
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent flex items-end p-6">
                    <h3 className="text-2xl font-serif font-bold text-white">{ind.title}</h3>
                  </div>
                </div> 
                
                <div className="p-8 flex-1 flex flex-col justify-between">
                  <p className="text-brand-grayBrown text-sm leading-relaxed mb-6">
                    {ind.description} 

                </p>
                  
                  <div className="bg-[#faeee2] p-5 rounded-2xl border border-[#f2decb]">
                    <h4 className="text-xs font-bold text-brand-orange uppercase tracking-wider mb-3">Key Solutions</h4>
                    <ul className="space-y-2">
                      {ind.solutions.map((sol, sIdx) => (
                        <li key={sIdx} className="text-xs md:text-sm font-semibold text-brand-darkBrown flex items-center gap-2">
                          <span className="w-1.5 h-1.5 rounded-full bg-brand-orange"></span>
                          {sol}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#f2decb]/80 border-t border-[#a17644]/20 px-6 text-center">
        <div className="max-w-4xl mx-auto" data-aos="zoom-in">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-deepBrown mb-6">
            Looking for Industry-Specific Intelligence?
          </h2>
          <p className="text-brand-grayBrown text-base md:text-lg mb-8 max-w-2xl mx-auto">
            Our strategic advisors provide specialized research reports customized to your sector requirements.
          </p>
          <Link
            to="/contact"
            className="inline-block px-8 py-4 bg-brand-orange text-white font-semibold rounded-full hover:bg-brand-darkBrown transition-colors duration-300 shadow-md text-sm uppercase tracking-wider"
          >
            Request Market Briefing
          </Link>
        </div>
      </section>
    </div>
  );
};

export default IndustriesPage;